export default "__VITE_ASSET__DrQdbN7P__"